export const ORIGINAL_SPIN_RESPONSE_DEFAULTS: any = {};
